import {IProfession, Lang, LocalStorage, ProfessionType} from "../../../../common/types";
import {withTranslation} from 'react-i18next';
import React, {useCallback, useMemo, useState} from "react";
import {getCurrentLang} from "../../../../common/utils/lang";
import PlayScreen from "../../../../common/components/game-screens/PlayScreen";
import Button from "../../../../common/components/Button";
import T from "../../../../common/i18n/Text";
import GameImage from "../../../../common/components/GameImage";
import {getNextRandomAndSaveAsUsed} from "../../../../common/utils/storage";

const professions: IProfession[] = require("../professions.json");

interface Props {
    professionTypes: ProfessionType[];
    showConfig: () => void;
    showInfo: () => void;
}

const InterviewGamePlay = ({ professionTypes, showConfig, showInfo }: Props) => {
    const activeLang:Lang = getCurrentLang();

    const professionsByType = useMemo<IProfession[]>((): IProfession[] => {
        return professions.filter((profession) => professionTypes.includes(profession.type));
    }, [professionTypes]);

    const getNextRandomProfession = useCallback(() => {
        const filterMapper = (prof:IProfession):string => prof.title[Lang.EN];
        return getNextRandomAndSaveAsUsed(professionsByType, LocalStorage.VIEWED_PROFESSIONS_STORAGE, filterMapper);
    }, [professionsByType]);

    const [currentProfession, changeCurrentProfession] = useState<IProfession>(getNextRandomProfession());

    const nextBtnHandleClick = () => {
        changeCurrentProfession(getNextRandomProfession());
    };

    const currentProfessionTitle = currentProfession?.title[activeLang];
    const currentProfessionDescription = currentProfession?.description[activeLang];

    const actionButton = <Button type="primary" onClick={nextBtnHandleClick} name="interview-next" keyboardKeys={["ArrowRight", " ", "Enter"]}>
                            <T path="games.buttons.next" />
                        </Button>;

    const content = currentProfession ? <GameImage imgSrc={currentProfession.image}
                                              imgTitle={currentProfessionTitle}
                                              imgDescription={currentProfessionDescription} />
                                              : null;

    return (
        <PlayScreen mainActions={actionButton} showConfig={showConfig} showInfo={showInfo}>
            {content}
        </PlayScreen>)
};

export default withTranslation()(InterviewGamePlay);
